export default __webpack_public_path__ + "static/media/print-icon.03f9ee2b.svg";